import React from 'react'
import Appbar from '../appbar/appbar'
import { BaseLayout } from './base-layout'

/**
 * Layout for functionality to be used by daily users
 */
export function UsersLayout({ children }: { children: JSX.Element | JSX.Element[] }): JSX.Element {
  return <BaseLayout appbar={<Appbar />}>{children}</BaseLayout>
}
